<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';
  import SelecaoBusca from './SelecaoBusca.vue';
  import RateioProjetos from './RateioProjetos.vue';
  import PernasTransitoria from './PernasTransitoria.vue';
  import ComplementoSugerido from './ComplementoSugerido.vue';
  import sugestoesDoHistorico, { nomeDoHistorico } from '../sugestoes-historico';
  import BlocoOperacao from './BlocoOperacao.vue';
  import ContasReceberVinculadas, { somaContasReceber } from './ContasReceberVinculadas.vue';
  import NotaFiscalVinculo from './NotaFiscalVinculo.vue';
  import AnexosOperacao from './AnexosOperacao.vue';
  import anexosMixin, { DESTINO_LANCAMENTO, DESTINO_CONTA_RECEBER, DESTINO_SOLICITACAO } from '../anexos';

  const OPERACOES = [
    {
      valor: 'conta-receber', curto: 'Contas a receber', icone: 'fa-file-text-o',
      titulo: 'Contas a receber —',
      texto: 'cria o título do cliente com o valor deste débito, baixado agora ou em aberto.',
    },
    {
      valor: 'sei-cliente', curto: 'Sei o cliente', icone: 'fa-user',
      titulo: 'Sei o cliente —',
      texto: 'cria o contas a receber em aberto e a transferência para a conta certa; o título baixa na data da transferência.',
    },
    {
      valor: 'conta-errada', curto: 'Conta errada', icone: 'fa-exchange',
      titulo: 'Conta errada —',
      texto: 'move o valor para a conta certa, entre contas reais, e pode vincular o contas a receber que já existe. Não cria título.',
    },
  ];

  export default {
    components: { SelecaoBusca, DatePicker, RateioProjetos, PernasTransitoria, ComplementoSugerido,
                  BlocoOperacao, AnexosOperacao, ContasReceberVinculadas, NotaFiscalVinculo },
    mixins: [anexosMixin],
    props: {
      idContaCript: { type: String, required: true },
      debito: { type: Object, required: true },
      nomeContaTransitoria: { type: String, default: '' },
    },
    data() {
      return {
        operacao: null,
        gravando: false,
        carregando: true,
        validar: false,
        origem: null,
        baixarAgora: null,
        viaSolicitacao: null,
        comTaxa: false,
        mostrarCheckTaxa: false,
        usaCategoria: false,
        categoriaObrigatoria: false,
        textosDocumento: [],
        textosComplemento: [],
        textosHistorico: [],
        anexosCr: [],
        vinculados: [],
        pernasValidas: false,
        observacaoSugerida: '',
        pedidoObservacao: 0,
        transf: {
          pernas: [],
          data: null,
          documento: '',
          complemento: '',
          idUsuarioLiberacao: 0, nomeUsuarioLiberacao: '',
          observacao: '',
        },
        form: {
          rateios: [],
          idTerceiro: 0, nomeTerceiro: '',
          tipoPessoa: 0,
          historico: '',
          idCategoriaFinanceira: 0, nomeCategoriaFinanceira: '',
          dataEmissao: null,
          dataVencimento: null,
          dataBaixa: null,
          documento: '',
          complemento: '',
          notaFiscal: null,
        },
      }
    },
    computed: {
      operacoes() { return OPERACOES; },
      operacaoAtiva() { return OPERACOES.find(o => o.valor === this.operacao) || null; },
      ehContaReceber() { return this.operacao === 'conta-receber'; },
      ehSeiCliente() { return this.operacao === 'sei-cliente'; },
      ehContaErrada() { return this.operacao === 'conta-errada'; },
      temContaReceber() { return this.ehContaReceber || this.ehSeiCliente; },
      temTransferencia() { return this.ehSeiCliente || this.ehContaErrada; },
      vinculadosEnvio() { return this.ehContaErrada ? this.vinculados : []; },
      buscaInicialCr() {
        const origem = this.origem || {};
        const documento = (origem.cpfCnpj || '').replace(/[^A-Za-z0-9]/g, '');
        return documento || (origem.nomeTerceiro || '').trim();
      },
      sugestoesCr() { return [((this.origem || {}).nomeTerceiro || '').trim()]; },
      sugestoesNf() {
        const origem = this.origem || {};
        const documento = (origem.cpfCnpj || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        const raiz = documento.length === 14
          ? documento.slice(0, 2) + '.' + documento.slice(2, 5) + '.' + documento.slice(5, 8)
          : '';
        return [raiz, this.buscaInicialCr, (origem.nomeTerceiro || '').trim(), nomeDoHistorico(origem.historico)]
          .filter(t => !!t);
      },
      nomeTransitoria() { return this.nomeContaTransitoria || 'Conta transitória'; },
      valor() { return this.origem ? this.origem.valor : (this.debito.valor || 0); },
      valorAbs() { return Math.abs(this.valor); },
      semCliente() { return this.form.tipoPessoa === 3; },
      sugestoesHistorico() { return sugestoesDoHistorico(this.origem && this.origem.historico, 110); },
      observacaoPorPerna() { return this.viaSolicitacao === true && this.transf.pernas.length > 1; },
      seloTransferencia() { return this.viaSolicitacao === true ? 'SOL' : 'TRANSF'; },
      corTransferencia() { return this.viaSolicitacao === true ? 'amb' : 'azu'; },
      tituloTransferencia() {
        return this.viaSolicitacao === true ? 'Solicitação de transferência' : 'Transferência entre contas';
      },
      subtituloTransferencia() {
        if (this.viaSolicitacao === true) return 'Nasce aguardando liberação — vira lançamento quando for liberada';
        if (this.viaSolicitacao === false) return 'Duas pernas lançadas agora, entre as contas reais';
        return 'Move o valor entre duas contas reais — a transitória não entra';
      },
      notaContaReceber() {
        if (this.ehSeiCliente)
          return this.viaSolicitacao === null
            ? 'Escolha como a transferência será lançada.'
            : 'Nasce em aberto. Quando a transferência for conciliada no banco, é baixado na data dela e este débito é conciliado com a data dele.';
        if (this.baixarAgora === true) return 'Nasce baixado e conciliado com este débito.';
        if (this.baixarAgora === false) return 'Nasce em aberto. Quando for baixado, este débito é conciliado sozinho.';
        return '';
      },
      podeAnexarTransferencia() {
        if (this.viaSolicitacao === true) return this.podeAnexarSolicitacao;
        if (this.viaSolicitacao === false) return this.podeAnexarLancamento;
        return false;
      },
      origensTra() {
        const semPessoa = !this.temContaReceber || this.semCliente || !(this.form.idTerceiro > 0);

        return this.origensAnexo({
          idLancamento: this.debito.idLancamento,
          comContasReceber: true,
          idPessoa: semPessoa ? 0 : this.form.idTerceiro,
          nomePessoa: semPessoa ? '' : this.form.nomeTerceiro,
          idsContaReceber: this.vinculadosEnvio.map(c => c.idLancamento),
        });
      },
      anexoTransferencia() {
        if (!this.podeAnexarTransferencia) return null;

        return {
          origens: this.origensTra,
          limite: this.limiteAnexo,
          titulo: this.viaSolicitacao === true ? 'Arquivos da solicitação' : 'Arquivos da transferência',
          dica: this.viaSolicitacao === true
            ? 'Os arquivos vão para a pasta desta solicitação de transferência.'
            : 'Os arquivos vão para a pasta de lançamentos, nas duas pernas desta transferência.',
        };
      },
      projetosRateio() {
        if (!this.temContaReceber) return [];
        return this.form.rateios.filter(r => r.idProjeto > 0).map(r => r.idProjeto);
      },
      chaveTaxa() {
        if (this.ehContaReceber && this.baixarAgora !== true) return '';
        if (this.ehSeiCliente && this.viaSolicitacao === null) return '';
        return this.projetosRateio.join(',');
      },
      chaveObservacao() {
        if (!this.temTransferencia || this.viaSolicitacao !== true) return '';
        return this.transf.pernas.map(p => (p.idContaOrigem || 0) + '>' + (p.idContaDestino || 0)).join(',')
          + '|' + this.projetosRateio.join(',');
      },
      rateioValido() {
        const rateios = this.form.rateios;

        if (!rateios || rateios.length === 0) return false;
        if (rateios.some(r => !(r.idProjeto > 0) || !(r.idRubrica > 0) || !(r.idSubRubrica > 0))) return false;
        if (rateios.some(r => !((+r.valor || 0) > 0))) return false;

        const chaves = rateios.map(r => r.idProjeto + '-' + r.idRubrica + '-' + r.idSubRubrica);
        if (chaves.some((c, i) => chaves.indexOf(c) !== i)) return false;

        const soma = rateios.reduce((s, r) => s + (+r.valor || 0), 0);

        return Math.abs(Math.round((soma - this.valorAbs) * 100) / 100) < 0.005;
      },
      erros() {
        const e = {};

        if (!this.operacao) {
          e.operacao = 'Escolha o que fazer com este débito';
          return e;
        }

        if (this.ehContaReceber) {
          if (this.baixarAgora === null) e.opcao = 'Escolha se o título nasce baixado ou em aberto';
          if (this.baixarAgora === true && !this.form.dataBaixa) e.dataBaixa = 'Campo obrigatório';
        }

        if (this.temContaReceber) {
          if (!this.form.tipoPessoa) e.tipoPessoa = 'Escolha o tipo';
          if (this.form.tipoPessoa > 0 && !this.semCliente && !this.form.idTerceiro) e.cliente = 'Campo obrigatório';
          if (this.semCliente && !this.form.historico.trim()) e.historico = 'Campo obrigatório';
          if (this.categoriaObrigatoria && !(this.form.idCategoriaFinanceira > 0)) e.categoria = 'Campo obrigatório';
          if (!this.rateioValido) e.rateio = 'Complete o rateio entre os projetos';
          if (!this.form.dataVencimento) e.vencimento = 'Campo obrigatório';
        }

        if (this.temTransferencia) {
          if (this.viaSolicitacao === null) e.modo = 'Escolha como lançar a transferência';
          if (!this.pernasValidas) e.pernas = 'Complete as contas da transferência';
          if (!this.transf.data) e.dataTransferencia = 'Campo obrigatório';

          if (this.viaSolicitacao === true) {
            if (!this.transf.idUsuarioLiberacao) e.liberador = 'Campo obrigatório';
            if (!this.observacaoPorPerna && !(this.transf.observacao || '').trim()) e.observacao = 'Campo obrigatório';
          }
        }

        if (this.vinculadosEnvio.length && Math.abs(somaContasReceber(this.vinculadosEnvio) - this.valorAbs) >= 0.005)
          e.crVinculo = 'A soma dos contas a receber tem que ser igual ao valor do débito';

        return e;
      },
      linhaCliente() {
        return (this.semCliente ? this.form.historico : this.form.nomeTerceiro) || 'Cliente do título';
      },
      resumoRateio() {
        const projetos = this.form.rateios.filter(r => r.idProjeto > 0);
        if (projetos.length === 0) return 'Selecione o projeto';
        if (projetos.length === 1) return projetos[0].nomeProjeto || 'Projeto do título';
        return 'Rateado entre ' + projetos.length + ' projetos';
      },
      previa() {
        const itens = [];

        if (this.temContaReceber)
          itens.push({
            chave: 'cr', rotulo: 'Contas a receber', cor: 'cre', valor: this.valorAbs, qtde: 1,
            linha: this.linhaCliente,
            nota: this.resumoRateio + ' · ' + (this.ehContaReceber && this.baixarAgora === true
              ? 'nasce baixado na ' + this.nomeTransitoria
              : 'nasce em aberto na ' + this.nomeTransitoria),
          });

        this.vinculadosEnvio.forEach(c => {
          itens.push({
            chave: 'vcr' + c.idLancamento, rotulo: 'Contas a receber ' + c.idLancamento, cor: 'cre', valor: c.valor, qtde: 0,
            vinculo: true,
            linha: c.nomePessoa || c.historico || 'Título existente',
            nota: +c.crOutraConta === 1
              ? 'Baixado na ' + this.nomeTransitoria + ' quando a transferência concluir · sai de ' + (c.nomeConta || 'outra conta')
              : 'Baixado na ' + this.nomeTransitoria + ' quando a transferência concluir',
          });
        });

        if (this.temTransferencia) {
          const pernas = this.transf.pernas.length ? this.transf.pernas : [{ valor: this.valorAbs }];

          pernas.forEach((perna, ix) => {
            const linha = `${perna.nomeContaOrigem || 'conta de origem'} → ${perna.nomeContaDestino || 'conta de destino'}`;
            const valor = pernas.length > 1 ? (+perna.valor || 0) : this.valorAbs;

            if (this.viaSolicitacao === true)
              itens.push({
                chave: 'sol' + ix, rotulo: 'Solicitação de transferência', cor: 'amb', valor, qtde: 0, linha,
                nota: 'Aguardando liberação. O lançamento é gerado quando ela for liberada.',
              });
            else
              itens.push({
                chave: 'tr' + ix, rotulo: 'Transferência', cor: 'azu', valor, qtde: 2, linha,
                nota: this.viaSolicitacao === false ? 'Duas pernas lançadas agora' : 'Escolha como lançar',
              });
          });
        }

        return itens;
      },
      totalLancamentos() { return this.previa.reduce((s, i) => s + i.qtde, 0); },
      conciliaAgora() { return this.ehContaReceber && this.baixarAgora === true; },
      resumoPrevia() {
        if (!this.operacao) return 'Escolha acima o que fazer com este débito.';

        if (this.totalLancamentos === 0)
          return 'Nenhum lançamento agora — só a solicitação. O débito fica pendente até ela ser liberada.';

        const plural = this.totalLancamentos === 1 ? '1 lançamento' : this.totalLancamentos + ' lançamentos';
        if (this.conciliaAgora) return plural + ' ao confirmar · o débito é conciliado na hora.';
        if (this.temContaReceber) return plural + ' ao confirmar · o débito é conciliado quando o título for baixado.';
        if (this.vinculadosEnvio.length) return plural + ' ao confirmar · o débito é conciliado quando a transferência concluir e o título vinculado for baixado.';
        return plural + ' ao confirmar · o débito fica pendente, com a transferência anotada no complemento.';
      },
      gruposPrevia() {
        const decorar = i => Object.assign({}, i, { mk: this.marcador(i) });
        const grupos = [];
        const agora = this.previa.filter(i => i.qtde > 0).map(decorar);
        const depois = this.previa.filter(i => i.qtde === 0 && !i.vinculo).map(decorar);
        const vinculo = this.previa.filter(i => i.vinculo).map(decorar);

        if (agora.length) grupos.push({ chave: 'agora', titulo: 'Ao confirmar', itens: agora });
        if (depois.length) grupos.push({ chave: 'depois', titulo: 'Depois da liberação', itens: depois });
        if (vinculo.length) grupos.push({ chave: 'vinculo', titulo: 'Vinculados (baixa automática)', itens: vinculo });

        return grupos;
      },
      totalAnexos() {
        let total = this.temContaReceber ? this.anexosCr.length : 0;
        if (this.temTransferencia) total += this.transf.pernas.reduce((s, p) => s + ((p.anexos || []).length), 0);
        return total;
      },
      rotuloBotao() {
        if (this.ehContaReceber) return this.baixarAgora === false ? 'Criar em aberto' : 'Criar e conciliar';
        if (this.ehSeiCliente) return 'Criar título e transferência';
        if (this.ehContaErrada) return this.viaSolicitacao === true ? 'Criar solicitação' : 'Criar transferência';
        return 'Gerar lançamentos';
      },
    },
    watch: {
      'transf.pernas.length'() { this.espalharObservacao(); },
      chaveTaxa(chave) { this.carregarCheckTaxa(chave); },
      viaSolicitacao() { this.espalharObservacao(); },
      chaveObservacao() { this.sugerirObservacao(); },
      operacao() { this.validar = false; },
    },
    mounted() {
      this.carregarDebito();
      this.carregarTextosPadrao();
      this.carregarConfigAnexos();
      this.carregarRegraCategoria();
    },
    methods: {
      erro(campo) { return this.validar ? this.erros[campo] : ''; },
      formatar(v) {
        return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      dataStr(d) { return d ? moment(d).format('YYYY-MM-DD') : ''; },
      marcador(item) {
        if (item.cor === 'amb') return { icone: 'fa-clock-o' };
        return item.qtde === 2 ? { icone: 'fa-exchange' } : { texto: 'CR' };
      },
      moverAba(indice, passo) {
        const destino = (indice + passo + OPERACOES.length) % OPERACOES.length;
        this.operacao = OPERACOES[destino].valor;
        this.$nextTick(() => {
          const abas = this.$refs.aba;
          if (abas && abas[destino]) abas[destino].focus();
        });
      },
      carregarDebito() {
        this.carregando = true;
        conciliacaoProjetoServico.debitoTransitoria(this.idContaCript, this.debito.idLancamento)
          .then(dados => {
            this.origem = dados;
            this.carregando = false;

            if (dados.idTerceiro > 0) {
              this.form.idTerceiro = dados.idTerceiro;
              this.form.nomeTerceiro = dados.nomeTerceiro;
            }

            this.form.dataEmissao = dados.dataStr ? moment(dados.dataStr, 'DD/MM/YYYY').toDate() : null;
            this.form.dataVencimento = this.form.dataEmissao;

            if (dados.idContaOrigem > 0)
              this.transf.pernas = [{
                idContaOrigem: dados.idContaOrigem, nomeContaOrigem: dados.nomeContaOrigem,
                idContaDestino: 0, nomeContaDestino: '',
                valor: 0, valorTexto: '',
                observacao: '', observacaoSugerida: '',
                anexos: [],
              }];
          })
          .catch(() => {
            this.carregando = false;
            toastr.error('Não foi possível carregar o lançamento de débito.');
            this.$emit('fechar');
          });
      },
      carregarTextosPadrao() {
        conciliacaoProjetoServico.textosPadrao()
          .then(dados => {
            this.textosDocumento = (dados && dados.documentos) || [];
            this.textosComplemento = (dados && dados.complementos) || [];
            this.textosHistorico = (dados && dados.historicos) || [];
          })
          .catch(() => {});
      },
      carregarRegraCategoria() {
        conciliacaoProjetoServico.regraCategoria(this.idContaCript)
          .then(r => {
            this.usaCategoria = !!(r && r.utiliza);
            this.categoriaObrigatoria = this.usaCategoria && !!(r && r.obrigatoria);
          })
          .catch(() => { this.usaCategoria = true; this.categoriaObrigatoria = false; });
      },
      carregarCheckTaxa(chave) {
        if (!chave) {
          this.mostrarCheckTaxa = false;
          this.comTaxa = false;
          return;
        }

        conciliacaoProjetoServico.checkTaxa(this.idContaCript, { idsProjeto: chave.split(',').map(x => +x) })
          .then(r => {
            if (this.chaveTaxa !== chave) return;
            this.mostrarCheckTaxa = !!(r && r.mostrar);
            this.comTaxa = !!(r && r.marcado);
          })
          .catch(() => { this.mostrarCheckTaxa = false; this.comTaxa = false; });
      },
      buscarContas(termo) { return conciliacaoProjetoServico.contasGerais(termo, true); },
      buscarUsuarios(termo) { return conciliacaoProjetoServico.usuariosLiberacao(termo); },
      buscarPessoas(termo) { return conciliacaoProjetoServico.pessoasCredito(termo, this.form.tipoPessoa); },
      buscarCategorias(termo) { return conciliacaoProjetoServico.categoriasFinanceiras(termo); },
      escolherTipoPessoa(tipo) {
        if (this.form.tipoPessoa === tipo) return;

        this.form.tipoPessoa = tipo;
        this.form.idTerceiro = 0;
        this.form.nomeTerceiro = '';
        this.form.notaFiscal = null;

        if (tipo > 0) this.form.historico = '';
      },
      aoEscolherCliente(opcao) {
        this.form.nomeTerceiro = opcao ? opcao.nome : '';
      },
      idsProjetoDe(rateios) {
        return (rateios || []).map(r => +r.idProjeto || 0).filter(id => id > 0);
      },
      clienteDaNotaFiscal(cliente) {
        if (cliente.tipoPessoa) this.form.tipoPessoa = cliente.tipoPessoa;
        this.form.idTerceiro = cliente.idPessoa;
        this.form.nomeTerceiro = cliente.nomePessoa;
      },
      notaFiscalEscolhida(nf) {
        this.form.notaFiscal = nf;
        if (!nf) return;
        if (!(this.form.documento || '').trim() && nf.numero) this.form.documento = String(nf.numero).slice(0, 30);
        if (!(this.form.complemento || '').trim() && nf.complemento) this.form.complemento = String(nf.complemento).slice(0, 300);
      },
      rateioDaNotaFiscal(rateios) {
        const formatar = v => v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const linhas = (rateios || []).filter(r => +r.idProjeto > 0).map(r => ({
          idProjeto: r.idProjeto, nomeProjeto: r.nomeProjeto || '',
          idRubrica: +r.idRubrica || 0, nomeRubrica: r.nomeRubrica || '',
          idSubRubrica: +r.idSubRubrica || 0, nomeSubrubrica: r.nomeSubrubrica || '',
          idItem: 0, nomeItem: '', exigeItem: false,
          quantidade: 1, quantidadeTexto: '1',
          valor: Math.round((+r.valor || 0) * 100) / 100,
          valorTexto: formatar(Math.round((+r.valor || 0) * 100) / 100),
        }));
        if (!linhas.length) return;

        if (!(this.form.rateios || []).some(r => r.idProjeto > 0)) {
          this.form.rateios = linhas;
          return;
        }

        this.$swal({
          title: 'Rateio da nota fiscal',
          text: 'A NF tem rateio por projeto. Deseja trocar o rateio já informado pelo da nota?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, usar o da NF',
          cancelButtonText: 'Manter o atual',
        })
          .then(result => { if (result === true || (result && result.value)) this.form.rateios = linhas; })
          .catch(() => {});
      },
      espalharObservacao() {
        if (!this.observacaoPorPerna) return;

        const texto = (this.transf.observacao || '').trim();

        if (!texto) return;

        this.transf.pernas.forEach(perna => {
          if (!(perna.observacao || '').trim()) this.$set(perna, 'observacao', texto);
        });
      },
      trechoConta(idConta, nome, idsProjeto) {
        const partes = (nome || '').split(' - C/C ');
        const conta = `CC ${(partes.length > 1 ? partes[partes.length - 1] : partes[0]).trim()}`;

        return conciliacaoProjetoServico.codigoProjetoConta(this.idContaCript, idConta, idsProjeto || [])
          .catch(() => '')
          .then(codigo => codigo === '()' ? `${conta} ()` : codigo ?`${conta} (${codigo.split(', ').map(c => 'P.' + c).join(', ')})` : conta);
      },
      textoObservacao(origem, destinos) {
        return `CRED. RECEBIDO INDEVIDAMENTE NA ${origem}. SOLICITO TRANSF. PARA ${destinos.join(' E ')}`.slice(0, 300);
      },
      sugerirObservacao() {
        const pernas = this.transf.pernas.filter(p => p.idContaOrigem > 0 && p.idContaDestino > 0);

        if (!this.temTransferencia || this.viaSolicitacao !== true || pernas.length === 0) return;

        const pedido = ++this.pedidoObservacao;
        const origens = Promise.all(pernas.map(p => this.trechoConta(p.idContaOrigem, p.nomeContaOrigem)));
        const destinos = Promise.all(pernas.map(p => this.trechoConta(p.idContaDestino, p.nomeContaDestino, this.projetosRateio)));

        Promise.all([origens, destinos]).then(([trechosOrigem, trechosDestino]) => {
          if (pedido !== this.pedidoObservacao) return;

          if (!this.observacaoPorPerna) {
            const texto = this.textoObservacao(trechosOrigem[0], trechosDestino);
            const atual = (this.transf.observacao || '').trim();

            if (!atual || this.transf.observacao === this.observacaoSugerida) this.transf.observacao = texto;

            this.observacaoSugerida = texto;
            return;
          }

          pernas.forEach((perna, i) => {
            const texto = this.textoObservacao(trechosOrigem[i], [trechosDestino[i]]);
            const atual = (perna.observacao || '').trim();

            if (!atual || perna.observacao === perna.observacaoSugerida) this.$set(perna, 'observacao', texto);

            this.$set(perna, 'observacaoSugerida', texto);
          });
        });
      },
      rateioParaEnvio() {
        return this.form.rateios.map(r => ({
          idProjeto: r.idProjeto,
          idRubrica: r.idRubrica,
          idSubRubrica: r.idSubRubrica,
          valor: +r.valor || 0,
        }));
      },
      contaReceberParaEnvio() {
        return {
          rateios: this.rateioParaEnvio(),
          idTerceiro: this.semCliente ? 0 : this.form.idTerceiro,
          historico: this.semCliente ? this.form.historico.trim() : '',
          idCategoriaFinanceira: this.form.idCategoriaFinanceira,
          dataEmissao: this.dataStr(this.form.dataEmissao),
          dataVencimento: this.dataStr(this.form.dataVencimento),
          documento: this.form.documento,
          complemento: this.form.complemento,
          valor: this.valorAbs,
          comTaxa: this.mostrarCheckTaxa && this.comTaxa,
          idNotaFiscal: !this.semCliente && this.form.notaFiscal ? this.form.notaFiscal.idNotaFiscal : 0,
        };
      },
      payload() {
        if (this.ehContaReceber)
          return {
            idLancamentoDebito: this.debito.idLancamento,
            operacao: 'CR',
            criarContaReceber: true,
            baixarAgora: this.baixarAgora === true,
            dataBaixa: this.baixarAgora === true ? this.dataStr(this.form.dataBaixa) : '',
            contaReceber: this.contaReceberParaEnvio(),
            criarTransferencia: false,
          };

        const lancarAgora = this.ehSeiCliente && this.viaSolicitacao === false;

        return {
          idLancamentoDebito: this.debito.idLancamento,
          operacao: 'TRANSFERENCIA',
          criarContaReceber: this.ehSeiCliente,
          baixarAgora: lancarAgora,
          dataBaixa: lancarAgora ? this.dataStr(this.transf.data) : '',
          contaReceber: this.ehSeiCliente ? this.contaReceberParaEnvio() : null,
          criarTransferencia: true,
          transferencias: this.transf.pernas.map(perna => ({
            idContaOrigem: perna.idContaOrigem,
            idContaDestino: perna.idContaDestino,
            valor: perna.valor,
            observacao: this.observacaoPorPerna ? (perna.observacao || '') : (this.transf.observacao || ''),
          })),
          dataTransferencia: this.dataStr(this.transf.data),
          documentoTransferencia: this.transf.documento,
          complementoTransferencia: this.transf.complemento,
          transferenciaViaSolicitacao: this.viaSolicitacao === true,
          idUsuarioLiberacao: this.viaSolicitacao === true ? this.transf.idUsuarioLiberacao : 0,
          observacaoSolicitacao: this.viaSolicitacao === true ? this.transf.observacao : '',
          idsContaReceber: this.vinculadosEnvio.map(c => c.idLancamento),
        };
      },
      enviosAnexos(resultado) {
        const envios = [];

        if (this.temTransferencia) {
          const pernas = this.transf.pernas;
          const multi = pernas.length > 1;
          const idsSolicitacao = resultado.idsSolicitacaoTransferencia && resultado.idsSolicitacaoTransferencia.length
            ? resultado.idsSolicitacaoTransferencia : [resultado.idSolicitacaoTransferencia];
          const idsLancamento = resultado.idsLancamentoTransferencia && resultado.idsLancamentoTransferencia.length
            ? resultado.idsLancamentoTransferencia
            : [resultado.idLancamentoDebitoTransferencia, resultado.idLancamentoCreditoTransferencia];

          pernas.forEach((perna, i) => {
            const sufixo = multi ? ' ' + (i + 1) : '';

            envios.push(this.viaSolicitacao === true
              ? { destino: DESTINO_SOLICITACAO, rotulo: 'solicitação de transferência' + sufixo,
                  ids: [idsSolicitacao[i]], arquivos: perna.anexos || [] }
              : { destino: DESTINO_LANCAMENTO, rotulo: 'transferência' + sufixo,
                  ids: [idsLancamento[i * 2], idsLancamento[i * 2 + 1]], arquivos: perna.anexos || [] });
          });
        }

        if (this.temContaReceber)
          envios.push({
            destino: DESTINO_CONTA_RECEBER, rotulo: 'contas a receber',
            ids: [resultado.idContaReceber], arquivos: this.anexosCr,
          });

        return envios;
      },
      irParaPrimeiroErro() {
        this.$nextTick(() => {
          const alvo = this.$el.querySelector('.rg-invalido, .rt-erro, .og-invalido, .pt-invalido');
          if (alvo) alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      },
      confirmar() {
        if (this.gravando || this.carregando || !this.operacao) return;

        this.validar = true;

        if (Object.keys(this.erros).length > 0) {
          toastr.error(this.erros.crVinculo || 'Preencha os campos obrigatórios destacados.');
          this.irParaPrimeiroErro();
          return;
        }

        this.gravando = true;

        conciliacaoProjetoServico.regularizarTransitoria(this.idContaCript, this.payload())
          .then(resultado => {
            return this.enviarAnexos(this.enviosAnexos(resultado)).then(() => {
              this.gravando = false;
              (resultado.mensagens || []).forEach(m => toastr.success(m));
              this.$emit('concluido', resultado);
            });
          })
          .catch(resposta => {
            this.gravando = false;
            const mensagem = resposta && resposta.data ? resposta.data.message : '';
            toastr.error(mensagem || 'Não foi possível concluir a operação.');
          });
      },
      fechar() { this.$emit('fechar'); },
    },
  }
</script>

<template>
  <div class="ov">
    <div class="ov-modal reg-modal">

      <div class="rg-head">
        <div>
          <h4>Regularizar débito da transitória</h4>
          <div class="rg-sub">
            <span class="mono">{{ origem ? origem.dataStr : debito.dataStr }}</span>
            <template v-if="origem && origem.historico">
              <span class="rg-pt">·</span>
              <span class="mono rg-hist" :title="origem.historico">{{ origem.historico }}</span>
            </template>
            <span class="rg-pt">·</span>
            <span class="mono">{{ nomeTransitoria }}</span>
          </div>
        </div>
        <div class="rg-valor">
          <div class="rg-valor-lbl">Débito a regularizar</div>
          <div class="rg-valor-num rg-valor-deb">R$ {{ formatar(valorAbs) }}</div>
        </div>
      </div>

      <div class="rg-barra">
        <div class="rg-barra-lbl">O que fazer com este débito?</div>
        <div class="rg-abas" role="tablist" aria-label="O que fazer com este débito?">
          <button v-for="(op, ix) in operacoes" :key="op.valor" ref="aba" type="button" role="tab"
                  class="rg-aba" :class="{ ativa: operacao === op.valor }"
                  :aria-selected="operacao === op.valor ? 'true' : 'false'"
                  :tabindex="operacao === op.valor || (!operacao && ix === 0) ? 0 : -1"
                  :disabled="carregando"
                  @click="operacao = op.valor"
                  @keydown.left.prevent="moverAba(ix, -1)" @keydown.right.prevent="moverAba(ix, 1)">
            <i class="fa" :class="op.icone"></i>{{ op.curto }}
          </button>
        </div>
        <div v-if="operacaoAtiva" class="rg-barra-aj"><b>{{ operacaoAtiva.titulo }}</b> {{ operacaoAtiva.texto }}</div>
      </div>

      <div class="rg-corpo">

        <div class="rg-passos" role="tabpanel" :aria-label="operacaoAtiva ? operacaoAtiva.titulo : ''">

          <div v-if="carregando" class="rg-vazio"><i class="fa fa-spinner fa-pulse"></i> Carregando o débito...</div>

          <div v-else-if="!operacao" class="rg-vazio">
            <i class="fa fa-hand-o-up rg-vazio-ic"></i>
            <div>Escolha acima o que fazer com este débito.</div>
          </div>

          <template v-else>

            <div class="rg-passo" v-if="ehContaReceber">
              <div class="rg-opcoes">
                <label class="rg-radio" :class="{ 'rg-radio-on': baixarAgora === true, 'rg-radio-erro': erro('opcao') }">
                  <input type="radio" :value="true" v-model="baixarAgora">
                  <span><b>Baixar agora</b><small>o título já nasce conciliado com este débito</small></span>
                </label>
                <label class="rg-radio" :class="{ 'rg-radio-on': baixarAgora === false, 'rg-radio-erro': erro('opcao') }">
                  <input type="radio" :value="false" v-model="baixarAgora">
                  <span><b>Deixar em aberto</b><small>o título fica a receber, para baixar depois</small></span>
                </label>
              </div>
              <span v-if="erro('opcao')" class="rg-msg rg-msg-bloco">{{ erro('opcao') }}</span>
            </div>

            <div class="rg-passo" v-if="ehContaErrada">
              <contas-receber-vinculadas v-model="vinculados" :id-conta-cript="idContaCript" :total="valorAbs"
                                         :busca-inicial="buscaInicialCr" :sugestoes="sugestoesCr" :nome-transitoria="nomeTransitoria"
                                         :validar="validar"></contas-receber-vinculadas>
            </div>

            <div class="rg-passo" v-if="temTransferencia">
              <bloco-operacao :selo="seloTransferencia" :cor="corTransferencia" :titulo="tituloTransferencia"
                              :subtitulo="subtituloTransferencia">
                <div class="rg-seg-lbl">Efeito</div>
                <div class="rg-seg" :class="{ 'rg-seg-erro': erro('modo') }">
                  <button type="button" :class="{ ativo: viaSolicitacao === false }" @click="viaSolicitacao = false">Lançar agora</button>
                  <button type="button" :class="{ ativo: viaSolicitacao === true }" @click="viaSolicitacao = true">Pedir liberação</button>
                </div>
                <span v-if="erro('modo')" class="rg-msg">{{ erro('modo') }}</span>
                <div class="rg-seg-aj">
                  <template v-if="viaSolicitacao === true">A transferência fica aguardando liberação e vira lançamento quando for liberada.</template>
                  <template v-else-if="viaSolicitacao === false">Gera as duas pernas da transferência agora, entre as contas reais.</template>
                  <template v-else>Escolha como a transferência será lançada.</template>
                </div>

                <pernas-transitoria v-model="transf.pernas" :total="valorAbs" :buscar="buscarContas"
                                    :validar="validar" :com-observacao="viaSolicitacao === true" :anexo="anexoTransferencia"
                                    :dica-origem="origem && origem.idContaOrigem > 0 ? 'Sugerida pelo crédito que originou este débito.' : ''"
                                    @valido="v => pernasValidas = v"></pernas-transitoria>

                <div class="rg-linha rg-linha-topo">
                  <div class="rg-campo rg-campo-sm" :class="{ 'rg-invalido': erro('dataTransferencia') }">
                    <label>Data <span class="rg-obr">*</span></label>
                    <date-picker v-model="transf.data" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                    <span v-if="erro('dataTransferencia')" class="rg-msg">{{ erro('dataTransferencia') }}</span>
                  </div>
                  <div class="rg-campo">
                    <label>Documento</label>
                    <complemento-sugerido v-model="transf.documento" :digitados="[transf.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                  <div class="rg-campo rg-campo-lg">
                    <label>Complemento <span class="muted">(opcional)</span></label>
                    <complemento-sugerido v-model="transf.complemento" :digitados="[transf.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento" :maxlength="300"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                </div>

                <div v-if="viaSolicitacao === true" class="rg-linha rg-linha-topo">
                  <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('liberador') }">
                    <label>Quem vai liberar <span class="rg-obr">*</span></label>
                    <selecao-busca v-model="transf.idUsuarioLiberacao" :texto="transf.nomeUsuarioLiberacao" :buscar="buscarUsuarios"
                                   placeholder="Buscar pessoa..."
                                   @selecionado="o => transf.nomeUsuarioLiberacao = o ? o.nome : ''"></selecao-busca>
                    <span v-if="erro('liberador')" class="rg-msg">{{ erro('liberador') }}</span>
                  </div>
                  <div v-if="!observacaoPorPerna" class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('observacao') }">
                    <label>Observação <span class="rg-obr">*</span></label>
                    <input type="text" class="form-control" maxlength="300" v-model="transf.observacao"
                           placeholder="Motivo da transferência">
                    <span v-if="erro('observacao')" class="rg-msg">{{ erro('observacao') }}</span>
                  </div>
                </div>
              </bloco-operacao>
            </div>

            <div class="rg-passo" v-if="temContaReceber">
              <bloco-operacao selo="CR" cor="cre" titulo="Contas a receber"
                              subtitulo="Título do cliente, com a conta transitória como conta de baixa"
                              :nota="notaContaReceber">
                <div class="rg-nf rg-nf-topo">
                  <label>Nota fiscal <span class="muted">(opcional)</span></label>
                  <nota-fiscal-vinculo :value="form.notaFiscal" @input="notaFiscalEscolhida"
                                       :id-pessoa="form.idTerceiro || 0" :nome-pessoa="form.nomeTerceiro" :permitir-outro-cliente="true"
                                       :ids-projeto="idsProjetoDe(form.rateios)" :total="valorAbs" :sugestoes="sugestoesNf"
                                       @cliente="clienteDaNotaFiscal" @rateios="rateioDaNotaFiscal"></nota-fiscal-vinculo>
                </div>
                <div class="rg-linha">
                  <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('cliente') || erro('historico') || erro('tipoPessoa') }">
                    <label>Cliente <span class="rg-obr">*</span></label>
                    <div class="rg-tp">
                      <button type="button" :class="{ ativo: form.tipoPessoa === 1 }" @click="escolherTipoPessoa(1)">Pessoa física</button>
                      <button type="button" :class="{ ativo: form.tipoPessoa === 2 }" @click="escolherTipoPessoa(2)">Pessoa jurídica</button>
                      <button type="button" :class="{ ativo: form.tipoPessoa === 3 }" @click="escolherTipoPessoa(3)">Outros</button>
                    </div>
                    <selecao-busca v-if="form.tipoPessoa > 0 && !semCliente" v-model="form.idTerceiro" :texto="form.nomeTerceiro"
                                   :buscar="buscarPessoas" :placeholder="form.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                   @selecionado="aoEscolherCliente"></selecao-busca>
                    <complemento-sugerido v-if="semCliente" v-model="form.historico" :sugestoes="sugestoesHistorico" :cadastrados="textosHistorico" :maxlength="110"
                                          titulo-sugestoes="Histórico do débito na transitória"
                                          placeholder="Clique para ver o histórico do débito"></complemento-sugerido>
                    <span v-if="erro('tipoPessoa')" class="rg-msg">{{ erro('tipoPessoa') }}</span>
                    <span v-else-if="erro('cliente')" class="rg-msg">{{ erro('cliente') }}</span>
                    <span v-else-if="erro('historico')" class="rg-msg">{{ erro('historico') }}</span>
                    <small v-else-if="semCliente" class="rg-dica">O título nasce sem pessoa, com este histórico.</small>
                  </div>
                  <div class="rg-campo rg-campo-lg">
                    <label>Conta de baixa</label>
                    <input type="text" class="form-control" :value="nomeTransitoria" disabled>
                  </div>
                </div>

                <div class="rg-linha" v-if="usaCategoria">
                  <div class="rg-campo rg-campo-lg" :class="{ 'rg-invalido': erro('categoria') }">
                    <label>Categoria financeira <span v-if="categoriaObrigatoria" class="rg-obr">*</span></label>
                    <selecao-busca v-model="form.idCategoriaFinanceira" :texto="form.nomeCategoriaFinanceira"
                                   :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                   @selecionado="o => form.nomeCategoriaFinanceira = o ? o.nome : ''"></selecao-busca>
                    <span v-if="erro('categoria')" class="rg-msg">{{ erro('categoria') }}</span>
                  </div>
                </div>

                <div class="rg-rateio">
                  <rateio-projetos v-model="form.rateios" :id-conta-cript="idContaCript" :total="valorAbs"
                                   natureza="C" :projetos-livres="true" :validar="validar"
                                   titulo="Rateio entre projetos"></rateio-projetos>
                </div>

                <div class="rg-linha">
                  <div class="rg-campo">
                    <label>Documento do título</label>
                    <complemento-sugerido v-model="form.documento" :digitados="[form.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                  <div class="rg-campo rg-campo-sm">
                    <label>Emissão</label>
                    <date-picker v-model="form.dataEmissao" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                  </div>
                  <div class="rg-campo rg-campo-sm" :class="{ 'rg-invalido': erro('vencimento') }">
                    <label>Vencimento <span class="rg-obr">*</span></label>
                    <date-picker v-model="form.dataVencimento" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                    <span v-if="erro('vencimento')" class="rg-msg">{{ erro('vencimento') }}</span>
                  </div>
                  <div class="rg-campo rg-campo-sm" v-if="ehContaReceber && baixarAgora === true" :class="{ 'rg-invalido': erro('dataBaixa') }">
                    <label>Data da baixa <span class="rg-obr">*</span></label>
                    <date-picker v-model="form.dataBaixa" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                                 :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                    <span v-if="erro('dataBaixa')" class="rg-msg">{{ erro('dataBaixa') }}</span>
                  </div>
                </div>

                <label v-if="chaveTaxa && mostrarCheckTaxa" class="rg-check">
                  <input type="checkbox" v-model="comTaxa">
                  <span>Taxa <small class="muted">marcado quando o projeto tem taxa cadastrada</small></span>
                </label>

                <div class="rg-linha rg-linha-topo">
                  <div class="rg-campo rg-campo-lg">
                    <label>Complemento <span class="muted">(opcional)</span></label>
                    <complemento-sugerido v-model="form.complemento" :digitados="[form.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento" :maxlength="300"
                                          placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                  </div>
                </div>


                <div v-if="podeAnexarContaReceber" class="rg-anexo">
                  <anexos-operacao v-model="anexosCr" :limite="limiteAnexo" :origens="origensTra"
                                   titulo="Arquivos do contas a receber"
                                   dica="Os arquivos vão para a pasta do contas a receber assim que o título for criado."></anexos-operacao>
                </div>
              </bloco-operacao>
            </div>

          </template>

        </div>

        <div class="rg-lateral">
          <div class="rg-lat-cab">
            <span class="rg-lat-tit">O que será gerado</span>
            <span v-if="operacao" class="rg-lat-selo" :class="conciliaAgora ? 'rg-lat-selo-ok' : 'rg-lat-selo-pend'">
              {{ conciliaAgora ? 'Concilia o débito' : 'Débito pendente' }}
            </span>
          </div>
          <div class="rg-lat-resumo">{{ resumoPrevia }}</div>

          <div v-for="g in gruposPrevia" :key="g.chave" class="rg-grupo">
            <div v-if="gruposPrevia.length > 1" class="rg-grupo-tit">{{ g.titulo }}</div>
            <div v-for="i in g.itens" :key="i.chave" class="rg-card">
              <span class="rg-mk" :class="'rg-mk-' + i.cor">
                <i v-if="i.mk.icone" class="fa" :class="i.mk.icone"></i>
                <template v-else>{{ i.mk.texto }}</template>
              </span>
              <div class="rg-card-txt">
                <div class="rg-card-topo">
                  <span class="rg-card-rot">{{ i.rotulo }}</span>
                  <span class="rg-card-val mono">R$ {{ formatar(i.valor) }}</span>
                </div>
                <div class="rg-card-linha">{{ i.linha }}</div>
                <div class="rg-card-nota">{{ i.nota }}</div>
              </div>
            </div>
          </div>

          <div class="rg-lat-cfg">
            <div class="rg-lat-cfg-tit">Débito na transitória</div>
            <div class="rg-lat-cfg-item"><b>Conta</b> {{ nomeTransitoria }}</div>
            <div class="rg-lat-cfg-item"><b>Data</b> {{ origem ? origem.dataStr : '—' }}</div>
            <div class="rg-lat-cfg-item"><b>Histórico</b> {{ (origem && origem.historico) || '—' }}</div>
            <div v-if="origem && origem.idContaOrigem > 0" class="rg-lat-cfg-item"><b>Crédito de origem</b> {{ origem.nomeContaOrigem }}</div>
          </div>
        </div>

      </div>

      <div class="rg-foot">
        <div class="rg-foot-l">
          Valor R$ {{ formatar(valorAbs) }}
          <template v-if="operacao">
            <span class="rg-pt">·</span>
            {{ totalLancamentos }} lançamento<span v-if="totalLancamentos !== 1">s</span>
          </template>
          <template v-if="totalAnexos > 0">
            <span class="rg-pt">·</span>
            {{ totalAnexos }} arquivo<span v-if="totalAnexos !== 1">s</span>
          </template>
          <button v-if="validar && Object.keys(erros).length > 0" type="button" class="rg-foot-erros" @click="irParaPrimeiroErro">
            <i class="fa fa-exclamation-circle"></i>
            {{ Object.keys(erros).length }} pendência<span v-if="Object.keys(erros).length !== 1">s</span> — ver
          </button>
        </div>
        <div class="rg-foot-r">
          <button class="btn-primary" :disabled="gravando || carregando || !operacao" @click="confirmar">
            <i class="fa" :class="gravando ? 'fa-spinner fa-pulse' : 'fa-check'"></i> {{ rotuloBotao }}
          </button>
          <button class="rd-btn rd-sair" @click="fechar"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
  .ov { position: fixed; inset: 0; background: rgba(16,24,40,.55); z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .ov-modal { background: #fff; border-radius: 8px; width: 96vw; max-width: 1180px; max-height: 94vh; display: flex; flex-direction: column; box-shadow: 0 10px 40px rgba(16,24,40,.2); overflow: hidden; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
  .muted { color: #8a939c; font-weight: normal; }

  .rg-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; padding: 15px 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; }
  .rg-head h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .rg-sub { display: flex; align-items: center; gap: 7px; margin-top: 4px; font-size: 12px; color: #6b747e; min-width: 0; }
  .rg-hist { max-width: 460px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rg-pt { color: #b6bdc5; }
  .rg-valor { text-align: right; flex: none; }
  .rg-valor-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #8a939c; }
  .rg-valor-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 22px; font-weight: 600; margin-top: 2px; }
  .rg-valor-deb { color: #a13c3c; }

  .rg-corpo { flex: 1 1 auto; min-height: 0; display: grid; grid-template-columns: 1fr 340px; gap: 0; overflow: hidden; }
  .rg-passos { overflow: auto; padding: 16px 20px 20px; }
  .rg-lateral { overflow: auto; padding: 16px 18px 20px; background: #fafbfc; border-left: 1px solid #e6e9ed; }

  .rg-barra { flex: 0 0 auto; padding: 12px 20px 13px; background: #fff; border-bottom: 1px solid #e6e9ed; }
  .rg-barra-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #8a939c; margin-bottom: 7px; }
  .rg-abas { display: flex; flex-wrap: wrap; gap: 7px; }
  .rg-aba { display: inline-flex; align-items: center; gap: 7px; height: 34px; padding: 0 15px; background: #fff; border: 1px solid #dfe3e8; border-radius: 6px; font-size: 12.5px; color: #5b6570; }
  .rg-aba .fa { font-size: 12px; color: #9aa3ac; }
  .rg-aba:hover { background: #f4f6f8; border-color: #c6ccd4; }
  .rg-aba:disabled { opacity: .6; }
  .rg-aba.ativa { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; font-weight: 600; box-shadow: 0 0 0 1px rgba(15,138,95,.18); }
  .rg-aba.ativa .fa { color: #0f8a5f; }
  .rg-aba:focus { outline: 2px solid #2d6cb3; outline-offset: 2px; }
  .rg-aba:focus:not(:focus-visible) { outline: none; }
  .rg-barra-aj { margin-top: 8px; font-size: 12px; color: #6b747e; line-height: 1.45; }
  .rg-barra-aj b { color: #3b444d; font-weight: 600; }

  .rg-passo { margin-bottom: 18px; }
  .rg-passo:last-child { margin-bottom: 0; }

  .rg-seg-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #8a939c; margin-bottom: 5px; }
  .rg-seg { display: inline-flex; border: 1px solid #c6ccd4; border-radius: 5px; overflow: hidden; }
  .rg-seg-erro { border-color: #c0392b; }
  .rg-seg button { height: 32px; padding: 0 16px; background: #fff; border: none; border-left: 1px solid #e2e6ea; font-size: 12.5px; color: #5b6570; }
  .rg-seg button:first-child { border-left: none; }
  .rg-seg button:hover { background: #f4f6f8; }
  .rg-seg button.ativo { background: #e8f5ef; color: #0a6d4d; font-weight: 600; box-shadow: inset 0 -2px 0 #0f8a5f; }
  .rg-seg-aj { font-size: 11.5px; color: #7b848e; line-height: 1.45; margin: 7px 0 12px; }

  .rg-linha { display: flex; gap: 10px; margin-bottom: 10px; }
  .rg-linha:last-child { margin-bottom: 0; }
  .rg-linha-topo { margin-top: 12px; }
  .rg-rateio { margin-bottom: 10px; }
  .rg-campo { flex: 1 1 0; min-width: 0; }
  .rg-campo-lg { flex: 2 1 0; }
  .rg-campo-sm { flex: 0 0 148px; }
  .rg-campo label { display: block; font-size: 12px; font-weight: 500; color: #3b444d; margin-bottom: 4px; }
  .rg-obr { color: #c0392b; }
  .rg-tp { display: flex; border: 1px solid #c6ccd4; border-radius: 5px; overflow: hidden; height: 32px; margin-bottom: 6px; }
  .rg-tp button { flex: 1; border: none; background: #fff; color: #5b6570; font-size: 12.5px; padding: 0 8px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .rg-tp button:first-child { border-left: none; }
  .rg-tp button:hover { background: #f4f6f8; }
  .rg-tp button.ativo { background: #e8f5ef; color: #0a6d4d; font-weight: 600; box-shadow: inset 0 -2px 0 #0f8a5f; }

  .rg-nf { margin-top: 10px; }
  .rg-nf-topo { margin: 0 0 12px; padding-bottom: 12px; border-bottom: 1px dashed #e1e6eb; }
  .rg-nf > label { display: block; font-size: 12px; font-weight: 500; color: #3b444d; margin-bottom: 4px; }
  .rg-dica { display: block; margin-top: 4px; font-size: 11.5px; color: #8a939c; }
  .rg-anexo { margin-top: 12px; padding-top: 12px; border-top: 1px solid #eef1f4; }

  .rg-opcoes { display: flex; gap: 10px; margin-bottom: 4px; }
  .rg-radio { flex: 1; display: flex; align-items: flex-start; gap: 8px; margin: 0; padding: 10px 12px; border: 1px solid #dfe3e8; border-radius: 7px; font-weight: normal; cursor: pointer; }
  .rg-radio:hover { background: #f7f9fa; }
  .rg-radio input { margin: 2px 0 0; }
  .rg-radio b { display: block; font-size: 12.5px; color: #2a3038; }
  .rg-radio small { display: block; font-size: 11.5px; color: #8a939c; margin-top: 2px; }
  .rg-radio-on { border-color: #0f8a5f; background: #f4faf7; box-shadow: inset 0 0 0 1px #0f8a5f; }
  .rg-radio-erro { border-color: #c0392b; background: #fdf6f5; }

  .rg-msg { display: block; margin-top: 4px; font-size: 11.5px; color: #c0392b; }
  .rg-msg-bloco { margin: 0 0 8px; }

  .rg-check { display: flex; align-items: center; gap: 8px; margin: 12px 0 0; font-weight: normal; font-size: 12.5px; color: #3b444d; cursor: pointer; }
  .rg-check input { margin: 0; }

  .rg-vazio { padding: 40px 30px; text-align: center; color: #8a939c; font-size: 13px; }
  .rg-vazio-ic { display: block; font-size: 26px; color: #c6ccd4; margin-bottom: 10px; }

  .rg-lat-cab { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
  .rg-lat-tit { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #7b848e; }
  .rg-lat-selo { flex: none; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; border-radius: 10px; padding: 3px 9px; }
  .rg-lat-selo-ok { background: #e3f3ec; color: #0a6d4d; }
  .rg-lat-selo-pend { background: #fdf3e0; color: #8a6d1f; }
  .rg-lat-resumo { font-size: 12px; color: #6b747e; line-height: 1.5; margin: 6px 0 13px; }

  .rg-grupo { margin-bottom: 13px; }
  .rg-grupo:last-child { margin-bottom: 0; }
  .rg-grupo-tit { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #9aa3ac; margin-bottom: 6px; }
  .rg-card { display: flex; gap: 9px; background: #fff; border: 1px solid #e6e9ed; border-radius: 6px; padding: 9px 11px; margin-bottom: 7px; }
  .rg-card:last-child { margin-bottom: 0; }
  .rg-card-txt { flex: 1 1 auto; min-width: 0; }
  .rg-mk { flex: none; display: inline-flex; align-items: center; justify-content: center; width: 21px; height: 21px; margin-top: 1px; border-radius: 5px; font-size: 10.5px; font-weight: 700; }
  .rg-mk .fa { font-size: 10px; }
  .rg-mk-cre { background: #e3f3ec; color: #0a6d4d; }
  .rg-mk-azu { background: #e7effa; color: #2d6cb3; }
  .rg-mk-amb { background: #fdf3e0; color: #8a6d1f; }
  .rg-card-topo { display: flex; justify-content: space-between; align-items: baseline; gap: 10px; }
  .rg-card-rot { font-size: 11.5px; font-weight: 600; color: #3b444d; }
  .rg-card-val { font-size: 13px; font-weight: 600; color: #1c2024; }
  .rg-card-linha { font-size: 12.5px; color: #1c2024; margin-top: 3px; line-height: 1.35; }
  .rg-card-nota { font-size: 11.5px; color: #8a939c; margin-top: 2px; line-height: 1.4; }

  .rg-lat-cfg { margin-top: 14px; padding-top: 12px; border-top: 1px solid #e6e9ed; }
  .rg-lat-cfg-tit { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #7b848e; margin-bottom: 7px; }
  .rg-lat-cfg-item { font-size: 11.5px; color: #5b6570; line-height: 1.5; margin-bottom: 3px; word-break: break-word; }
  .rg-lat-cfg-item b { display: block; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #9aa3ac; }

  .rg-foot { flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 12px 20px; background: #f7f9fa; border-top: 1px solid #e6e9ed; }
  .rg-foot-l { font-size: 12px; color: #6b747e; }
  .rg-foot-r { display: flex; gap: 8px; }

  .btn-primary { height: 34px; padding: 0 20px; background: #0f8a5f; border: 1px solid #0d7a54; color: #fff; font-size: 13px; font-weight: 600; border-radius: 5px; box-shadow: 0 1px 2px rgba(15,138,95,.3); }
  .btn-primary:hover { background: #0d7a54; }
  .btn-primary:disabled { opacity: .6; }
  .rd-btn { display: inline-flex; align-items: center; gap: 7px; background: #fff; border: 1px solid #c6ccd4; border-radius: 5px; padding: 8px 14px; font-size: 12.5px; color: #3b444d; }
  .rd-btn:hover { background: #f4f6f8; }
  .rd-sair { background: #fdf1f1; border-color: #e4d7d7; color: #a13c3c; font-weight: 600; padding: 8px 18px; }
  .rd-sair:hover { background: #fbe7e7; border-color: #d9c2c2; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/RegularizarTransitoriaModal.vue